import React, {FC, ReactElement} from 'react';
import styled from 'styled-components';
import './Group.scss';
import Element from '../elements/Element';

interface MainState {
}

export type groupProps = {
    index:number|null,
    path: {
        slideIndex:number,
        comboIndex:number,
        setIndex: number,
        groupIndex: number,
        elementIndex: number|null,
        subElementIndex: number|null
    }|null,
    elements:any,
    width:string,
    editorPlugins: any|null,
    mobileOrder:number|null
}

type groupDesignedProps = {
    width:string,
    isDraggingOver:boolean,
    isDragging:boolean,
    mobileOrder:number|null
}


export const GroupDesigned = styled.div<groupDesignedProps>`
&.group {
    width: ${props => props.width + '%'};
    @media (max-width:768px) {
        ${props => props.mobileOrder &&`
            order: ${props.mobileOrder}
       `};
   }
}
`;

const Group:FC<groupProps> = ({...props}) : ReactElement => {

    let isEditor = props.editorPlugins;

    if(isEditor) {
       const GroupEditor = require('./GroupEditor').default
       return <GroupEditor {...props}/>;
    }
    else {
        return (<GroupDesigned className={"group pos-" + props.index} width={props.width} isDraggingOver={false} isDragging={false} mobileOrder={props.mobileOrder}>
            {
                props.elements.map((element: any, index: number) => {
                    return <Element key={index} elementData={element} index={null} path={null} editorPlugins={null}/>
                })
            }
        </GroupDesigned>);
    }
}

Group.defaultProps = {

}

export default Group;
